/**
 * Utility functions for handling form field values and placeholders
 */

export interface GetFieldPlaceholderParams {
  fieldValue: unknown;
  explicitValue?: unknown;
  customPlaceholder?: string;
  label?: string;
}

/**
 * Determines the actual value to use for a form field
 * @param fieldValue - The current value from Formik
 * @param explicitValue - Explicit value passed to the field (optional)
 * @returns The actual value to use (explicit value takes priority over fieldValue)
 */
export const getInputValue = (fieldValue: unknown, explicitValue?: unknown): string => {
  if (explicitValue !== undefined && explicitValue !== null) {
    return String(explicitValue);
  }

  if (fieldValue !== undefined && fieldValue !== null) {
    return String(fieldValue);
  }

  return '';
};

/**
 * Determines the appropriate placeholder text for a form field
 * @param params - Object containing all parameters for placeholder determination
 * @returns The placeholder text to display
 */
export const getFieldPlaceholder = (params: GetFieldPlaceholderParams): string => {
  const { fieldValue, explicitValue, customPlaceholder, label } = params;
  const actualValue = getInputValue(fieldValue, explicitValue);
  const hasValue = actualValue.trim() !== '';
  return hasValue ? '' : (customPlaceholder ?? (label ? `Type ${label}` : 'Enter value'));
};
